import Vue from 'vue'
import VueRouter from 'vue-router'
import Text from '../views/text/Text.vue'
import Text2 from '../views/text/Text2.vue'

import Home from '../views/Home.vue'
import STYJ from '../views/STYJ.vue'
import CYXW from '../views/CYXW.vue'
import XFWM from '../views/XFWM.vue'
import ZLYX from '../views/ZLYX.vue'
import SHFY from '../views/SHFY.vue'

import MSHD from '../views/view/MSHD.vue'
import MJGS from '../views/view/MJGS.vue'
import TSFW from '../views/view/TSFW.vue'




Vue.use(VueRouter)

const routes = [
  {
    path: '/text',
    name: 'Text',
    component: Text,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/text2',
    name: 'Text2',
    component: Text2,
    meta: {
      keepAlive: false
    }
  },



  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true
    }
  },

  {
    path: '/styj',
    name: 'STYJ',
    component: STYJ,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/cyxw',
    name: 'CYXW',
    component: CYXW,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/xfwm',
    name: 'XFWM',
    component: XFWM,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/zlyx',
    name: 'ZLYX',
    component: ZLYX,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/shfy',
    name: 'SHFY',
    component: SHFY,
    meta: {
      keepAlive: true
    }
  },


  {
    path: '/mshd',
    name: 'MSHD',
    component: MSHD,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/mjgs',
    name: 'MJGS',
    component: MJGS,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/tsfw',
    name: 'TSFW',
    component: TSFW,
    meta: {
      keepAlive: true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
